import { useEffect } from 'react'
import { Auth } from 'aws-amplify'
import { BI_DASHBOARD_URL } from '../../Components/Constants/Constants'
const useBiSessionHandoff = () => {
    useEffect(() => {
        const biOrigin = new URL(BI_DASHBOARD_URL).origin
        const onBiAuthRequest = (event) => {
            if (event.origin !== biOrigin || !event.source) {
                return
            }
            if (!event.data || event.data.type !== 'i95dev:bi-auth-request') {
                return
            }
            const reply = (tokens) => {
                event.source.postMessage({ type: 'i95dev:bi-auth-tokens', ...tokens }, event.origin)
            }
            Auth.currentSession()
                .then((session) => reply({
                    idToken: session.getIdToken().getJwtToken(),
                    accessToken: session.getAccessToken().getJwtToken(),
                    refreshToken: session.getRefreshToken().getToken()
                }))
                .catch(() => reply({}))
        }

        window.addEventListener('message', onBiAuthRequest)
        return () => window.removeEventListener('message', onBiAuthRequest)
    }, [])
}

export default useBiSessionHandoff
